import React from 'react';

const Mutasi = () => {
  return (
    <h1>Mutasi</h1>
  );
};

export default Mutasi;





